module.exports = __webpack_public_path__ + "img/BARRY_80X30.10cc45ce.png";